export const branch = 'branch1';
export const graphqlURI = `https://foodo.jadwal.io/graphql`;
export const baseUrl = `https://foodo.jadwal.io`;
// export const branch = 'branch3';
// export const graphqlURI = 'http://jadwal-server/graphql';
export const startSales = false;
export const defaultSettings: any = {
  themeMode: 'light', // 'light' | 'dark'
  themeDirection: 'rtl', //  'rtl' | 'ltr' - matches default Arabic language
  themeContrast: 'default', // 'default' | 'bold'
  themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
  themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
  themeStretch: false,
};
